export const DemandFlexibilitySlider = [
  {
    title: "Maharashtra – Demand Flexibility Regulations",
    points: ["The values are for 2021 and at USD at 2021 PPP"],
    link: "https://merc.gov.in/regulation_type/current-regulations-demand-side-management/",
  },
];

const MAP_CENTER = [0, 55] as [number, number];

const MAP_LEGENDS = [
  {
    value: "moderate",
    color: "#1B6894",
    discription:
      "Potential for energy savings is moderate. Additional energy savings are possibly, commonly through improved market transformation. Review energy efficiency policies, raise ambition and commitments.",
  },
  {
    value: "moderate to high",
    color: "#98D7C5",
    discription:
      "Potential for energy savings is moderate to high. Improve existing and develop new energy efficiency policies that fill existing policy gaps. Increase knowledge and investment in research and development.",
  },
  {
    value: "high",
    color: "#64C4A8",
    discription:
      "Potential for energy savings is high. Develop energy efficiency policies that fill existing policy gaps. Improve knowledge, skills, and expertise in energy efficiency. Set long-term goals and ambitions e.g. setting NDCs.",
  },
  {
    value: "high to significant",
    color: "#1F6E9E",
    discription:
      "Potential for energy savings is high to significant. Increased knowledge and awareness of energy efficiency benefits by key stakeholders. Assessment of energy efficiency opportunities. Development of energy efficiency strategies and roadmaps.",
  },
  {
    value: "significant",
    color: "#003350",
    discription:
      "Potential for energy savings is significant. Raising awareness on energy efficiency benefits are paramount at this stage. Countries are encouraged to convene stakeholders and identify new energy efficiency policies that could support an enabling environment for investment in energy efficiency.",
  },
  {
    value: "vast",
    color: "#C2DDF4",
    discription:
      "Potential for energy savings is vast. Immediate action is required to capture energy efficiency potential in the short term. Raising awareness on energy efficiency benefits are paramount at this stage. Countries are encouraged to make energy efficiency data and analysis available to better understand immediate opportunities and cost-effective measures for energy efficiency in the sector.",
  },
];

const SECTORS_LIST = [
  {
    title: "Residential",
    field_name: "field_residential_score",
    icon: "homeIcon",
  },
  { title: "Industry", field_name: "field_industry_score", icon: "dollar" },
  {
    title: "Commercial and public services",
    field_name: "field_services_score",
    icon: "chart",
  },
  { title: "Transport", field_name: "field_transport_score", icon: "bus" },
  {
    title: "Electricity distribution and transmission",
    field_name: "field_electricity_and_heat_score",
    icon: "bulb",
  },
];

const ANNUAL_IMPROVEMENT_KEYS: { [key: string]: string } = {
  field_country_score: "field_ai_country",
  field_electricity_and_heat_score: "field_ai_electricity_and_heat",
  field_industry_score: "field_ai_industry",
  field_residential_score: "field_ai_residential",
  field_services_score: "field_ai_service",
  field_transport_score: "field_ai_transport",
};

const MONTHS_LIST = [
  { label: "January", value: "01" },
  { label: "February", value: "02" },
  { label: "March", value: "03" },
  { label: "April", value: "04" },
  { label: "May", value: "05" },
  { label: "June", value: "06" },
  { label: "July", value: "07" },
  { label: "August", value: "08" },
  { label: "September", value: "09" },
  { label: "October", value: "10" },
  { label: "November", value: "11" },
  { label: "December", value: "12" },
];

const YEAR_LIST = [
  { label: "2007", value: "2007" },
  { label: "2008", value: "2008" },
  { label: "2009", value: "2009" },
  { label: "2010", value: "2010" },
  { label: "2011", value: "2011" },
  { label: "2012", value: "2012" },
  { label: "2013", value: "2013" },
  { label: "2014", value: "2014" },
  { label: "2015", value: "2015" },
  { label: "2016", value: "2016" },
  { label: "2017", value: "2017" },
  { label: "2018", value: "2018" },
  { label: "2019", value: "2019" },
  { label: "2020", value: "2020" },
  { label: "2021", value: "2021" },
  { label: "2022", value: "2022" },
  { label: "2023", value: "2023" },
  { label: "2024", value: "2024" },
];

const NEWS_AND_TRAINING_KEY_MAPPINGS = {
  title: ["title"],
  date: ["field_t_date", "field_news_date"],
  description: ["field_news_blurb", "field_summary"],
  language: ["field_t_language"],
  link: ["field_t_link", "field_news_link"],
  modality: ["field_t_modality"],
  organisation: ["field_t_organization"],
  region: ["field_t_region"],
  resource: ["field_t_resource", "field_n_resource"],
  sector: ["field_t_sector"],
  topic: ["field_t_topic"],
  location: ["field_location"],
  organizer: ["field_organisers"],
  speakers: ["field_add_speakers"],
  summary: ["field_summary"],
  register: ["field_register_form"],
  time: ["field_time"],
  external: ["field_mark_as_external_source"],
  name: ["field_name"],
  media: ["field_t_media_url", "field_news_media_url"],
  field_image: ["field_image"],
  field_related_content: ["field_related_content"],
};

const LANGUAGE_CODE = {
  english: "EN",
  spanish: "ES",
  french: "FR",
  chinese: "ZH",
  portuguese: "PT",
};

let ZOOM = 1.2;
let MAX_ZOOM = 5;
const browserWidth = globalThis.innerWidth;
if (browserWidth && window) {
  ZOOM = window?.innerWidth > 768 ? Number(1.2) : Number(1.1);
  MAX_ZOOM = window?.innerWidth > 768 ? Number(5) : Number(9);
}

export const CONSTS = {
  ZOOM,
  MAX_ZOOM,
  MAP_CENTER,
  MAP_LEGENDS,
  SECTORS_LIST,
  ANNUAL_IMPROVEMENT_KEYS,
  MONTHS_LIST,
  YEAR_LIST,
  NEWS_AND_TRAINING_KEY_MAPPINGS,
  LANGUAGE_CODE,
};

export const countries = [
  {
    name: "Afghanistan",
    code: "AF",
    continent: "Asia",
    country_iso: "AFG",
  },
  {
    name: "Albania",
    code: "AL",
    continent: "Europe",
    country_iso: "ALB",
  },
  {
    name: "Algeria",
    code: "DZ",
    continent: "Africa",
    country_iso: "DZA",
  },
  {
    name: "American Samoa",
    code: "AS",
    continent: "Oceania",
    country_iso: "ASM",
  },
  {
    name: "Andorra",
    code: "AD",
    continent: "Europe",
    country_iso: "AND",
  },
  {
    name: "Angola",
    code: "AO",
    continent: "Africa",
    country_iso: "AGO",
  },
  {
    name: "Antigua and Barbuda",
    code: "AG",
    continent: "North America",
    country_iso: "ATG",
  },
  {
    name: "Argentina",
    code: "AR",
    continent: "South America",
    country_iso: "ARG",
  },
  {
    name: "Armenia",
    code: "AM",
    continent: "Asia",
    country_iso: "ARM",
  },
  {
    name: "Aruba",
    code: "AW",
    continent: "North America",
    country_iso: "ABW",
  },
  {
    name: "Australia",
    code: "AU",
    continent: "Oceania",
    country_iso: "AUS",
  },
  {
    name: "Austria",
    code: "AT",
    continent: "Europe",
    country_iso: "AUT",
  },
  {
    name: "Azerbaijan",
    code: "AZ",
    continent: "Asia",
    country_iso: "AZE",
  },
  {
    name: "Bahamas",
    code: "BS",
    continent: "North America",
    country_iso: "BHS",
  },
  {
    name: "Bahrain",
    code: "BH",
    continent: "Asia",
    country_iso: "BHR",
  },
  {
    name: "Bangladesh",
    code: "BD",
    continent: "Asia",
    country_iso: "BGD",
  },
  {
    name: "Barbados",
    code: "BB",
    continent: "North America",
    country_iso: "BRB",
  },
  {
    name: "Belarus",
    code: "BY",
    continent: "Europe",
    country_iso: "BLR",
  },
  {
    name: "Belgium",
    code: "BE",
    continent: "Europe",
    country_iso: "BEL",
  },
  {
    name: "Belize",
    code: "BZ",
    continent: "North America",
    country_iso: "BLZ",
  },
  {
    name: "Benin",
    code: "BJ",
    continent: "Africa",
    country_iso: "BEN",
  },
  {
    name: "Bermuda",
    code: "BM",
    continent: "North America",
    country_iso: "BMU",
  },
  {
    name: "Bhutan",
    code: "BT",
    continent: "Asia",
    country_iso: "BTN",
  },
  {
    name: "Bolivia",
    code: "BO",
    continent: "South America",
    country_iso: "BOL",
  },
  {
    name: "Bosnia and Herzegovina",
    code: "BA",
    continent: "Europe",
    country_iso: "BIH",
  },
  {
    name: "Botswana",
    code: "BW",
    continent: "Africa",
    country_iso: "BWA",
  },
  {
    name: "Brazil",
    code: "BR",
    continent: "South America",
    country_iso: "BRA",
  },
  {
    name: "British Virgin Islands",
    code: "VG",
    continent: "North America",
    country_iso: "VGB",
  },
  {
    name: "Brunei Darussalam",
    code: "BN",
    continent: "Asia",
    country_iso: "BRN",
  },
  {
    name: "Bulgaria",
    code: "BG",
    continent: "Europe",
    country_iso: "BGR",
  },
  {
    name: "Burkina Faso",
    code: "BF",
    continent: "Africa",
    country_iso: "BFA",
  },
  {
    name: "Burundi",
    code: "BI",
    continent: "Africa",
    country_iso: "BDI",
  },
  {
    name: "Cabo Verde",
    code: "CV",
    continent: "Africa",
    country_iso: "CPV",
  },
  {
    name: "Cambodia",
    code: "KH",
    continent: "Asia",
    country_iso: "KHM",
  },
  {
    name: "Cameroon",
    code: "CM",
    continent: "Africa",
    country_iso: "CMR",
  },
  {
    name: "Canada",
    code: "CA",
    continent: "North America",
    country_iso: "CAN",
  },
  {
    name: "Cayman Islands",
    code: "KY",
    continent: "North America",
    country_iso: "CYM",
  },
  {
    name: "Central African Republic",
    code: "CF",
    continent: "Africa",
    country_iso: "CAF",
  },
  {
    name: "Chad",
    code: "TD",
    continent: "Africa",
    country_iso: "TCD",
  },
  {
    name: "Chile",
    code: "CL",
    continent: "South America",
    country_iso: "CHL",
  },
  {
    name: "China",
    code: "CN",
    continent: "Asia",
    country_iso: "CHN",
  },
  {
    name: "Hong Kong, China",
    code: "HK",
    continent: "Asia",
    country_iso: "HKG",
  },
  {
    name: "Macao, China",
    code: "MO",
    continent: "Asia",
    country_iso: "MAC",
  },
  {
    name: "Colombia",
    code: "CO",
    continent: "South America",
    country_iso: "COL",
  },
  {
    name: "Comoros",
    code: "KM",
    continent: "Africa",
    country_iso: "COM",
  },
  {
    name: "Congo",
    code: "CG",
    continent: "Africa",
    country_iso: "COG",
  },
  {
    name: "Costa Rica",
    code: "CR",
    continent: "North America",
    country_iso: "CRI",
  },
  {
    name: "Côte d'Ivoire",
    code: "CI",
    continent: "Africa",
    country_iso: "CIV",
  },
  {
    name: "Croatia",
    code: "HR",
    continent: "Europe",
    country_iso: "HRV",
  },
  {
    name: "Cuba",
    code: "CU",
    continent: "North America",
    country_iso: "CUB",
  },
  {
    name: "Curaçao",
    code: "CW",
    continent: "South America",
    country_iso: "CUW",
  },
  {
    name: "Cyprus",
    code: "CY",
    continent: "Asia",
    country_iso: "CYP",
  },
  {
    name: "Czechia",
    code: "CZ",
    continent: "Europe",
    country_iso: "CZE",
  },
  {
    name: "Democratic People's Republic of Korea",
    code: "KP",
    continent: "Asia",
    country_iso: "PRK",
  },
  {
    name: "Democratic Republic of the Congo",
    code: "CD",
    continent: "Africa",
    country_iso: "COD",
  },
  {
    name: "Denmark",
    code: "DK",
    continent: "Europe",
    country_iso: "DNK",
  },
  {
    name: "Djibouti",
    code: "DJ",
    continent: "Africa",
    country_iso: "DJI",
  },
  {
    name: "Dominica",
    code: "DM",
    continent: "North America",
    country_iso: "DMA",
  },
  {
    name: "Dominican Republic",
    code: "DO",
    continent: "North America",
    country_iso: "DOM",
  },
  {
    name: "Ecuador",
    code: "EC",
    continent: "South America",
    country_iso: "ECU",
  },
  {
    name: "Egypt",
    code: "EG",
    continent: "Africa",
    country_iso: "EGY",
  },
  {
    name: "El Salvador",
    code: "SV",
    continent: "North America",
    country_iso: "SLV",
  },
  {
    name: "Equatorial Guinea",
    code: "GQ",
    continent: "Africa",
    country_iso: "GNQ",
  },
  {
    name: "Eritrea",
    code: "ER",
    continent: "Africa",
    country_iso: "ERI",
  },
  {
    name: "Estonia",
    code: "EE",
    continent: "Europe",
    country_iso: "EST",
  },
  {
    name: "Eswatini",
    code: "SZ",
    continent: "Africa",
    country_iso: "SWZ",
  },
  {
    name: "Ethiopia",
    code: "ET",
    continent: "Africa",
    country_iso: "ETH",
  },
  {
    name: "Fiji",
    code: "FJ",
    continent: "Oceania",
    country_iso: "FJI",
  },
  {
    name: "Finland",
    code: "FI",
    continent: "Europe",
    country_iso: "FIN",
  },
  {
    name: "France",
    code: "FR",
    continent: "Europe",
    country_iso: "FRA",
  },
  {
    name: "Gabon",
    code: "GA",
    continent: "Africa",
    country_iso: "GAB",
  },
  {
    name: "Gambia",
    code: "GM",
    continent: "Africa",
    country_iso: "GMB",
  },
  {
    name: "Georgia",
    code: "GE",
    continent: "Asia",
    country_iso: "GEO",
  },
  {
    name: "Germany",
    code: "DE",
    continent: "Europe",
    country_iso: "DEU",
  },
  {
    name: "Ghana",
    code: "GH",
    continent: "Africa",
    country_iso: "GHA",
  },
  {
    name: "Gibraltar",
    code: "GI",
    continent: "Europe",
    country_iso: "GIB",
  },
  {
    name: "Greece",
    code: "GR",
    continent: "Europe",
    country_iso: "GRC",
  },
  {
    name: "Grenada",
    code: "GD",
    continent: "North America",
    country_iso: "GRD",
  },
  {
    name: "Guatemala",
    code: "GT",
    continent: "North America",
    country_iso: "GTM",
  },
  {
    name: "Guinea",
    code: "GN",
    continent: "Africa",
    country_iso: "GIN",
  },
  {
    name: "Guinea-Bissau",
    code: "GW",
    continent: "Africa",
    country_iso: "GNB",
  },
  {
    name: "Guyana",
    code: "GY",
    continent: "South America",
    country_iso: "GUY",
  },
  {
    name: "Haiti",
    code: "HT",
    continent: "North America",
    country_iso: "HTI",
  },
  {
    name: "Holy See",
    code: "VA",
    continent: "Europe",
    country_iso: "VAT",
  },
  {
    name: "Honduras",
    code: "HN",
    continent: "North America",
    country_iso: "HND",
  },
  {
    name: "Hungary",
    code: "HU",
    continent: "Europe",
    country_iso: "HUN",
  },
  {
    name: "Iceland",
    code: "IS",
    continent: "Europe",
    country_iso: "ISL",
  },
  {
    name: "India",
    code: "IN",
    continent: "Asia",
    country_iso: "IND",
  },
  {
    name: "Indonesia",
    code: "ID",
    continent: "Asia",
    country_iso: "IDN",
  },
  {
    name: "Iran",
    code: "IR",
    continent: "Asia",
    country_iso: "IRN",
  },
  {
    name: "Iraq",
    code: "IQ",
    continent: "Asia",
    country_iso: "IRQ",
  },
  {
    name: "Ireland",
    code: "IE",
    continent: "Europe",
    country_iso: "IRL",
  },
  {
    name: "Israel",
    code: "IL",
    continent: "Asia",
    country_iso: "ISR",
  },
  {
    name: "Italy",
    code: "IT",
    continent: "Europe",
    country_iso: "ITA",
  },
  {
    name: "Jamaica",
    code: "JM",
    continent: "North America",
    country_iso: "JAM",
  },
  {
    name: "Japan",
    code: "JP",
    continent: "Asia",
    country_iso: "JPN",
  },
  {
    name: "Jordan",
    code: "JO",
    continent: "Asia",
    country_iso: "JOR",
  },
  {
    name: "Kazakhstan",
    code: "KZ",
    continent: "Asia",
    country_iso: "KAZ",
  },
  {
    name: "Kenya",
    code: "KE",
    continent: "Africa",
    country_iso: "KEN",
  },
  {
    name: "Kiribati",
    code: "KI",
    continent: "Oceania",
    country_iso: "KIR",
  },
  {
    name: "Kuwait",
    code: "KW",
    continent: "Asia",
    country_iso: "KWT",
  },
  {
    name: "Kyrgyzstan",
    code: "KG",
    continent: "Asia",
    country_iso: "KGZ",
  },
  {
    name: "Lao People's Democratic Republic",
    code: "LA",
    continent: "Asia",
    country_iso: "LAO",
  },
  {
    name: "Latvia",
    code: "LV",
    continent: "Europe",
    country_iso: "LVA",
  },
  {
    name: "Lebanon",
    code: "LB",
    continent: "Asia",
    country_iso: "LBN",
  },
  {
    name: "Lesotho",
    code: "LS",
    continent: "Africa",
    country_iso: "LSO",
  },
  {
    name: "Liberia",
    code: "LR",
    continent: "Africa",
    country_iso: "LBR",
  },
  {
    name: "Libya",
    code: "LY",
    continent: "Africa",
    country_iso: "LBY",
  },
  {
    name: "Liechtenstein",
    code: "LI",
    continent: "Europe",
    country_iso: "LIE",
  },
  {
    name: "Lithuania",
    code: "LT",
    continent: "Europe",
    country_iso: "LTU",
  },
  {
    name: "Luxembourg",
    code: "LU",
    continent: "Europe",
    country_iso: "LUX",
  },
  {
    name: "Madagascar",
    code: "MG",
    continent: "Africa",
    country_iso: "MDG",
  },
  {
    name: "Malawi",
    code: "MW",
    continent: "Africa",
    country_iso: "MWI",
  },
  {
    name: "Malaysia",
    code: "MY",
    continent: "Asia",
    country_iso: "MYS",
  },
  {
    name: "Maldives",
    code: "MV",
    continent: "Asia",
    country_iso: "MDV",
  },
  {
    name: "Mali",
    code: "ML",
    continent: "Africa",
    country_iso: "MLI",
  },
  {
    name: "Malta",
    code: "MT",
    continent: "Europe",
    country_iso: "MLT",
  },
  {
    name: "Marshall islands",
    code: "MH",
    continent: "Oceania",
    country_iso: "MHL",
  },
  {
    name: "Mauritania",
    code: "MR",
    continent: "Africa",
    country_iso: "MRT",
  },
  {
    name: "Mauritius",
    code: "MU",
    continent: "Africa",
    country_iso: "MUS",
  },
  {
    name: "Mexico",
    code: "MX",
    continent: "North America",
    country_iso: "MEX",
  },
  {
    name: "Micronesia (Federated States of)",
    code: "FM",
    continent: "Oceania",
    country_iso: "FSM",
  },
  {
    name: "Monaco",
    code: "MC",
    continent: "Europe",
    country_iso: "MCO",
  },
  {
    name: "Mongolia",
    code: "MN",
    continent: "Asia",
    country_iso: "MNG",
  },
  {
    name: "Montenegro",
    code: "ME",
    continent: "Europe",
    country_iso: "MNE",
  },
  {
    name: "Morocco",
    code: "MA",
    continent: "Africa",
    country_iso: "MAR",
  },
  {
    name: "Mozambique",
    code: "MZ",
    continent: "Africa",
    country_iso: "MOZ",
  },
  {
    name: "Myanmar",
    code: "MM",
    continent: "Asia",
    country_iso: "MMR",
  },
  {
    name: "Namibia",
    code: "NA",
    continent: "Africa",
    country_iso: "NAM",
  },
  {
    name: "Nauru",
    code: "NR",
    continent: "Oceania",
    country_iso: "NRU",
  },
  {
    name: "Nepal",
    code: "NP",
    continent: "Asia",
    country_iso: "NPL",
  },
  {
    name: "Netherlands",
    code: "NL",
    continent: "Europe",
    country_iso: "NLD",
  },
  {
    name: "New Zealand",
    code: "NZ",
    continent: "Oceania",
    country_iso: "NZL",
  },
  {
    name: "Nicaragua",
    code: "NI",
    continent: "North America",
    country_iso: "NIC",
  },
  {
    name: "Niger",
    code: "NE",
    continent: "Africa",
    country_iso: "NER",
  },
  {
    name: "Nigeria",
    code: "NG",
    continent: "Africa",
    country_iso: "NGA",
  },
  {
    name: "North Macedonia",
    code: "MK",
    continent: "Europe",
    country_iso: "MKD",
  },
  {
    name: "Norway",
    code: "NO",
    continent: "Europe",
    country_iso: "NOR",
  },
  {
    name: "Oman",
    code: "OM",
    continent: "Asia",
    country_iso: "OMN",
  },
  {
    name: "Pakistan",
    code: "PK",
    continent: "Asia",
    country_iso: "PAK",
  },
  {
    name: "Palau",
    code: "PW",
    continent: "Oceania",
    country_iso: "PLW",
  },
  {
    name: "Panama",
    code: "PA",
    continent: "North America",
    country_iso: "PAN",
  },
  {
    name: "Papua New Guinea",
    code: "PG",
    continent: "Oceania",
    country_iso: "PNG",
  },
  {
    name: "Paraguay",
    code: "PY",
    continent: "South America",
    country_iso: "PRY",
  },
  {
    name: "Peru",
    code: "PE",
    continent: "South America",
    country_iso: "PER",
  },
  {
    name: "Philippines",
    code: "PH",
    continent: "Asia",
    country_iso: "PHL",
  },
  {
    name: "Poland",
    code: "PL",
    continent: "Europe",
    country_iso: "POL",
  },
  {
    name: "Portugal",
    code: "PT",
    continent: "Europe",
    country_iso: "PRT",
  },
  {
    name: "Puerto Rico (USA)",
    code: "PR",
    continent: "North America",
    country_iso: "PRI",
  },
  {
    name: "Qatar",
    code: "QA",
    continent: "Asia",
    country_iso: "QAT",
  },
  {
    name: "Republic of Korea",
    code: "KR",
    continent: "Asia",
    country_iso: "KOR",
  },
  {
    name: "Republic of Moldova",
    code: "MD",
    continent: "Europe",
    country_iso: "MDA",
  },
  {
    name: "Romania",
    code: "RO",
    continent: "Europe",
    country_iso: "ROU",
  },
  {
    name: "Russian Federation",
    code: "RU",
    continent: "Europe",
    country_iso: "RUS",
  },
  {
    name: "Rwanda",
    code: "RW",
    continent: "Africa",
    country_iso: "RWA",
  },
  {
    name: "Saint Barthelemy",
    code: "BL",
    continent: "North America",
    country_iso: "BLM",
  },
  {
    name: "Saint Helena",
    code: "SH",
    continent: "Africa",
    country_iso: "SHN",
  },
  {
    name: "Saint Kitts and Nevis",
    code: "KN",
    continent: "North America",
    country_iso: "KNA",
  },
  {
    name: "Saint Lucia",
    code: "LC",
    continent: "North America",
    country_iso: "LCA",
  },
  {
    name: "Saint Martin",
    code: "MF",
    continent: "Europe",
    country_iso: "MAF",
  },
  {
    name: "Saint Pierre and Miquelon",
    code: "PM",
    continent: "North America",
    country_iso: "SPM",
  },
  {
    name: "Saint Vincent and the Grenadines",
    code: "VC",
    continent: "North America",
    country_iso: "VCT",
  },
  {
    name: "Samoa",
    code: "WS",
    continent: "Oceania",
    country_iso: "WSM",
  },
  {
    name: "San Marino",
    code: "SM",
    continent: "Europe",
    country_iso: "SMR",
  },
  {
    name: "Sao Tome and Principe",
    code: "ST",
    continent: "Africa",
    country_iso: "STP",
  },
  {
    name: "Saudi Arabia",
    code: "SA",
    continent: "Asia",
    country_iso: "SAU",
  },
  {
    name: "Senegal",
    code: "SN",
    continent: "Africa",
    country_iso: "SEN",
  },
  {
    name: "Serbia",
    code: "RS",
    continent: "Europe",
    country_iso: "SRB",
  },
  {
    name: "Seychelles",
    code: "SC",
    continent: "Africa",
    country_iso: "SYC",
  },
  {
    name: "Sierra Leone",
    code: "SL",
    continent: "Africa",
    country_iso: "SLE",
  },
  {
    name: "Singapore",
    code: "SG",
    continent: "Asia",
    country_iso: "SGP",
  },
  {
    name: "Sint Maarten",
    code: "SX",
    continent: "North America",
    country_iso: "SXM",
  },
  {
    name: "Slovakia",
    code: "SK",
    continent: "Europe",
    country_iso: "SVK",
  },
  {
    name: "Slovenia",
    code: "SI",
    continent: "Europe",
    country_iso: "SVN",
  },
  {
    name: "Solomon islands",
    code: "SB",
    continent: "Oceania",
    country_iso: "SLB",
  },
  {
    name: "Somalia",
    code: "SO",
    continent: "Africa",
    country_iso: "SOM",
  },
  {
    name: "South Africa",
    code: "ZA",
    continent: "Africa",
    country_iso: "ZAF",
  },
  {
    name: "South Sudan",
    code: "SS",
    continent: "Africa",
    country_iso: "SSD",
  },
  {
    name: "Spain",
    code: "ES",
    continent: "Europe",
    country_iso: "ESP",
  },
  {
    name: "Sri Lanka",
    code: "LK",
    continent: "Asia",
    country_iso: "LKA",
  },
  {
    name: "State of Palestine",
    code: "PS",
    continent: "Asia",
    country_iso: "PSE",
  },
  {
    name: "Sudan",
    code: "SD",
    continent: "Africa",
    country_iso: "SDN",
  },
  {
    name: "Suriname",
    code: "SR",
    continent: "South America",
    country_iso: "SUR",
  },
  {
    name: "Sweden",
    code: "SE",
    continent: "Europe",
    country_iso: "SWE",
  },
  {
    name: "Switzerland",
    code: "CH",
    continent: "Europe",
    country_iso: "CHE",
  },
  {
    name: "Syrian Arab Republic",
    code: "SY",
    continent: "Asia",
    country_iso: "SYR",
  },
  {
    name: "Tajikistan",
    code: "TJ",
    continent: "Asia",
    country_iso: "TJK",
  },
  {
    name: "Tanzania",
    code: "TZ",
    continent: "Africa",
    country_iso: "TZA",
  },
  {
    name: "Thailand",
    code: "TH",
    continent: "Asia",
    country_iso: "THA",
  },
  {
    name: "Timor-Leste",
    code: "TL",
    continent: "Asia",
    country_iso: "TLS",
  },
  {
    name: "Togo",
    code: "TG",
    continent: "Africa",
    country_iso: "TGO",
  },
  {
    name: "Tonga",
    code: "TO",
    continent: "Oceania",
    country_iso: "TON",
  },
  {
    name: "Trinidad and Tobago",
    code: "TT",
    continent: "North America",
    country_iso: "TTO",
  },
  {
    name: "Tunisia",
    code: "TN",
    continent: "Africa",
    country_iso: "TUN",
  },
  {
    name: "Turkey",
    code: "TR",
    continent: "Asia",
    country_iso: "TUR",
  },
  {
    name: "Turkmenistan",
    code: "TM",
    continent: "Asia",
    country_iso: "TKM",
  },
  {
    name: "Tuvalu",
    code: "TV",
    continent: "Oceania",
    country_iso: "TUV",
  },
  {
    name: "Uganda",
    code: "UG",
    continent: "Africa",
    country_iso: "UGA",
  },
  {
    name: "Ukraine",
    code: "UA",
    continent: "Europe",
    country_iso: "UKR",
  },
  {
    name: "United Arab Emirates",
    code: "AE",
    continent: "Asia",
    country_iso: "ARE",
  },
  {
    name: "United Kingdom of Great Britain and Northern Ireland",
    code: "GB",
    continent: "Europe",
    country_iso: "GBR",
  },
  {
    name: "United States Minor Outlying Islands",
    code: "UM",
    continent: "Oceania",
    country_iso: "UMI",
  },
  {
    name: "United States of America",
    code: "US",
    continent: "North America",
    country_iso: "USA",
  },
  {
    name: "United States Virgin Islands",
    code: "VI",
    continent: "North America",
    country_iso: "VIR",
  },
  {
    name: "Uruguay",
    code: "UY",
    continent: "South America",
    country_iso: "URY",
  },
  {
    name: "Uzbekistan",
    code: "UZ",
    continent: "Asia",
    country_iso: "UZB",
  },
  {
    name: "Vanuatu",
    code: "VU",
    continent: "Oceania",
    country_iso: "VUT",
  },
  {
    name: "Venezuela",
    code: "VE",
    continent: "South America",
    country_iso: "VEN",
  },
  {
    name: "Viet Nam",
    code: "VN",
    continent: "Asia",
    country_iso: "VNM",
  },
  {
    name: "Western Sahara",
    code: "EH",
    continent: "Africa",
    country_iso: "ESH",
  },
  {
    name: "Yemen",
    code: "YE",
    continent: "Asia",
    country_iso: "YEM",
  },
  {
    name: "Zambia",
    code: "ZM",
    continent: "Africa",
    country_iso: "ZMB",
  },
  {
    name: "Zimbabwe",
    code: "ZW",
    continent: "Africa",
    country_iso: "ZWE",
  },
];
